<template>
  <div class="alert-comments">
    <AlertComment v-for="comment in alert.comments" :key="comment.id" :comment="comment"
      v-on:create="createComment(comment)"
      v-on:update="updateComment(comment)"
      v-on:delete="deleteComment(comment)"
    />
    <div class="new-btn">
      <button @click="addComment">New comment</button>
    </div>
  </div>
</template>

<style scoped>
.new-btn {
  float: left;
}
</style>

<script>
import { mapState } from 'vuex'
import AlertComment from './AlertComment.vue'

export default {
  name: 'AlertComments',
  components: {
    AlertComment
  },
  props: {
    alert: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState([
      'debugMode',
      'apiAccount'
    ])
  },
  methods: {
    addComment () {
      this.alert.comments.push({
        creating: true,
        nick: '',
        text: ''
      })
    },
    createComment (comment) {
      var params = {
        nick: comment.nick,
        text: comment.text
      }
      this.apiAccount.post('/alerts/'+ this.alert.id + '/comments', params).then(response => {
        this.alert.comments = response.comments
      })
    },
    updateComment (comment) {
      var params = {
        nick: comment.nick,
        text: comment.text
      }
      this.apiAccount.put('/alerts/'+ this.alert.id + '/comments/' + comment.id, params).then(response => {
        this.alert.comments = response.comments
      })
    },
    deleteComment (comment) {
      // console.log('Delete comment', comment)
      if (!comment.id) {
        this.alert.comments.pop()
      } else {
        this.apiAccount.delete('/alerts/'+ this.alert.id + '/comments/' + comment.id).then(response => {
          this.alert.comments = response.comments
        })
      }
    }
  },
  data () {
    return {
    }
  }
}
</script>
